var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00A524"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_6947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 16.6562C13.2301 16.6562 12.9375 16.3637 12.9375 16C12.9375 15.6363 13.2301 15.3438 13.5938 15.3438H15.3438V13.5938C15.3438 13.2301 15.6363 12.9375 16 12.9375C16.3637 12.9375 16.6562 13.2301 16.6562 13.5938V15.3438H18.4062C18.7699 15.3438 19.0625 15.6363 19.0625 16C19.0625 16.3637 18.7699 16.6562 18.4062 16.6562H16.6562V18.4062C16.6562 18.7699 16.3637 19.0625 16 19.0625C15.6363 19.0625 15.3438 18.7699 15.3438 18.4062V16.6562H13.5938Z",
    fill: "#007C1B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9 16C9 12.1336 12.1336 9 16 9C19.8664 9 23 12.1336 23 16C23 19.8664 19.8664 23 16 23C12.1336 23 9 19.8664 9 16ZM16 19.0625C16.3637 19.0625 16.6562 18.7699 16.6562 18.4062V16.6562H18.4062C18.7699 16.6562 19.0625 16.3637 19.0625 16C19.0625 15.6363 18.7699 15.3438 18.4062 15.3438H16.6562V13.5938C16.6562 13.2301 16.3637 12.9375 16 12.9375C15.6363 12.9375 15.3438 13.2301 15.3438 13.5938V15.3438H13.5938C13.2301 15.3438 12.9375 15.6363 12.9375 16C12.9375 16.3637 13.2301 16.6562 13.5938 16.6562H15.3438V18.4062C15.3438 18.7699 15.6363 19.0625 16 19.0625Z",
    fill: "#007C1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_6947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdded);
export default __webpack_public_path__ + "static/media/added.cf4fbd81a7e69ec0631d426a18e54f60.svg";
export { ForwardRef as ReactComponent };